import { fromJS, List } from 'immutable';
import { useLocalStorage } from 'core/hooks';

export const useDemoQuizAttempts = (lessonId, questionId = null) => {
  const defaultQuizAttempts = List();

  const isImmutable = true;

  const [storedQuizAttempts, setStoredQuizAttempts] = useLocalStorage(
    questionId
      ? `quizAttempts_lessonId-${lessonId}_questionId-${questionId}`
      : `quizAttempts_lessonId-${lessonId}`,

    defaultQuizAttempts,
    isImmutable
  );

  const quizAttempts = fromJS(storedQuizAttempts);

  function save(lessonId, questionId, quizAttempt, callback) {
    // lessonId and questionId are not used in this demo
    // but they are used in the original useQuizAttempts hook
    const updatedQuizAttempts = quizAttempts.push(quizAttempt);

    setStoredQuizAttempts(updatedQuizAttempts);

    if (callback) {
      callback();
    }
  }

  return {
    data: quizAttempts,
    isLoading: false,
    error: false,
    save,
  };
};
